import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import logoSvg from '@/assets/images/logo.svg';
import { cn } from '@/lib/utils';

interface HeaderProps {
  leftContent?: ReactNode;
  centerContent?: ReactNode;
  rightContent?: ReactNode;
  variant?: 'default' | 'studio';
  className?: string;
  leftSlotClassName?: string;
  centerSlotClassName?: string;
  rightSlotClassName?: string;
  separatorClassName?: string;
}

export const Header = ({
  leftContent,
  centerContent,
  rightContent,
  variant = 'default',
  className,
  leftSlotClassName,
  centerSlotClassName,
  rightSlotClassName,
  separatorClassName,
}: HeaderProps) => {
  const isStudioVariant = variant === 'studio';

  return (
    <header
      className={cn(
        isStudioVariant
          ? 'studio-header dark:bg-card border-border sticky top-0 z-50 grid min-h-[58px] shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-x-4 border-b bg-white px-5 py-0'
          : 'dark:bg-card border-border sticky top-0 z-50 flex min-h-[58px] shrink-0 flex-wrap items-center justify-between gap-x-3 gap-y-2 border-b bg-[#f7f7fc] px-3 py-2 sm:h-[58px] sm:flex-nowrap sm:gap-4 sm:px-5 sm:py-0',
        className,
      )}
    >
      <div
        className={cn(
          isStudioVariant
            ? 'studio-header-left flex min-w-0 items-center gap-0'
            : 'flex min-w-0 shrink items-center gap-0',
          leftSlotClassName,
        )}
      >
        <Link to="/dashboard" className="flex shrink-0 items-center no-underline">
          <img src={logoSvg} alt="CoveAuto AI" height={26} style={{ display: 'block' }} />
        </Link>

        {leftContent ? (
          <>
            <div
              className={cn(
                isStudioVariant
                  ? 'studio-header-separator bg-border mx-3 h-[18px] w-px'
                  : 'bg-border mx-3 h-[18px] w-px',
                separatorClassName,
              )}
            />
            <div className="flex min-w-0 items-center">{leftContent}</div>
          </>
        ) : null}
      </div>

      {centerContent ? (
        <div
          className={cn(
            isStudioVariant
              ? 'studio-header-center flex min-w-0 items-center justify-center'
              : 'order-3 flex w-full min-w-0 justify-center sm:order-none sm:w-auto sm:flex-1',
            centerSlotClassName,
          )}
        >
          {centerContent}
        </div>
      ) : null}

      <div
        className={cn(
          isStudioVariant
            ? 'studio-header-right flex min-w-0 items-center justify-end gap-2'
            : 'flex max-w-full items-center gap-2 sm:shrink-0',
          rightSlotClassName,
        )}
      >
        {rightContent}
      </div>
    </header>
  );
};
